import type { StateCreator } from 'zustand';
import type { SliceMutators } from '~/store/mutators';

export type AnimationSlice = {
  animation: {
    selectedRow: number | null;
    /** Stack-all-frames overlay on the row guide. Useful for pixel-perfect alignment. */
    onionStack: boolean;
    isPlaying: boolean;
    currentFrame: number;
  };
  setSelectedRow: (r: number | null) => void;
  setOnionStack: (b: boolean) => void;
  setPlaying: (b: boolean) => void;
  setCurrentFrame: (i: number) => void;
  /** Move the playhead by `delta` frames within `count`, wrapping; pauses playback. */
  stepFrame: (delta: number, count: number) => void;
  resetAnimation: () => void;
};

const INITIAL_ANIMATION = {
  selectedRow: null,
  onionStack: false,
  isPlaying: true,
  currentFrame: 0,
} satisfies AnimationSlice['animation'];

export const createAnimationSlice: StateCreator<
  AnimationSlice,
  SliceMutators,
  [],
  AnimationSlice
> = (set) => ({
  animation: INITIAL_ANIMATION,
  setSelectedRow: (r) =>
    set((s) => {
      s.animation.selectedRow = r;
      s.animation.currentFrame = 0;
      s.animation.isPlaying = true;
    }),
  setOnionStack: (b) =>
    set((s) => {
      s.animation.onionStack = b;
    }),
  setPlaying: (b) =>
    set((s) => {
      s.animation.isPlaying = b;
    }),
  setCurrentFrame: (i) =>
    set((s) => {
      s.animation.currentFrame = i;
    }),
  stepFrame: (delta, count) =>
    set((s) => {
      if (count <= 0) return;
      s.animation.currentFrame = (((s.animation.currentFrame + delta) % count) + count) % count;
      s.animation.isPlaying = false;
    }),
  resetAnimation: () =>
    set((s) => {
      s.animation = { ...INITIAL_ANIMATION };
    }),
});
